import { ThemeConfig, theme } from 'antd';

const sharedTokens = {
  borderRadius: 6,
  fontSize: 14,
  lineHeight: 22 / 14,
  controlHeight: 32,
};

export const antdLightTheme: ThemeConfig = {
  token: {
    ...sharedTokens,
    colorPrimary: '#24252C',
    colorPrimaryHover: '#24252C',
    colorPrimaryActive: '#24252C',
  },
  components: {
    Button: {
      colorPrimary: '#24252C',
      colorPrimaryHover: 'rgba(36, 37, 44, 0.8)',
      colorPrimaryActive: 'rgba(36, 37, 44, 0.9)',
      primaryShadow: 'none',
      borderRadius: 8,
      defaultBorderColor: '#d9d9d9',
      defaultShadow: '0px 2px 0px 0px rgba(0,0,0,0.02)',
      paddingContentHorizontal: 15,
    },
    Checkbox: {
      colorPrimary: '#24252C',
      colorPrimaryHover: '#24252C',
      colorPrimaryBorder: '#24252C',
      borderRadiusSM: 4,
    },
    DatePicker: {
      colorPrimary: '#24252C',
      colorPrimaryHover: '#24252C',
      colorPrimaryActive: '#24252C',
      borderRadius: 6,
      colorTextPlaceholder: 'rgba(0, 0, 0, 0.40)',
      colorBorder: '#d9d9d9',
      colorText: 'rgba(0, 0, 0, 0.88)',
      colorTextSecondary: 'rgba(0, 0, 0, 0.88)',
      colorLink: '#24252C',
      colorLinkHover: '#24252C',
      colorBgContainer: '#ffffff',
      controlItemBgActive: 'rgba(36, 37, 44, 0.1)',
      controlItemBgHover: 'rgba(36, 37, 44, 0.05)',
    },
    Modal: {
      borderRadiusLG: 8,
      boxShadow:
        '0px 6px 16px 0px rgba(0,0,0,0.08),0px 3px 6px -4px rgba(0,0,0,0.12),0px 9px 28px 8px rgba(0,0,0,0.05)',
    },
    Select: {
      optionActiveBg: 'rgba(36, 37, 44, 0.1)',
      optionSelectedBg: 'rgba(36, 37, 44, 0.1)',
      optionSelectedFontWeight: 600,
      selectorBg: '#f9f9fa',
      colorBorder: '#d9d9d9',
      colorText: 'rgba(0, 0, 0, 0.88)',
      colorTextPlaceholder: 'rgba(0, 0, 0, 0.25)',
      borderRadius: 4,
      controlHeight: 30,
      fontSize: 14,
      colorPrimaryHover: '#24252C',
      colorPrimaryBorderHover: '#24252C',
      colorPrimaryBorder: '#24252C',
    },
    Menu: {
      itemBg: 'transparent',
      subMenuItemBg: 'transparent',
    },
  },
};

export const antdDarkTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    ...sharedTokens,
    colorPrimary: '#A8AAB8',
    colorPrimaryHover: '#A8AAB8',
    colorPrimaryActive: '#8F91A3',
    colorBgContainer: '#3C3D49',
    colorBgElevated: '#3C3D49',
    colorBgLayout: '#24252C',
    colorBorder: '#535565',
    colorBorderSecondary: '#3C3D49',
    colorText: '#F9F9FA',
    colorTextSecondary: '#A8AAB8',
    colorTextTertiary: '#8F91A3',
    colorTextQuaternary: '#6A6D81',
  },
  components: {
    Button: {
      colorPrimary: '#A8AAB8',
      colorPrimaryHover: 'rgba(168, 170, 184, 0.8)',
      colorPrimaryActive: 'rgba(168, 170, 184, 0.9)',
      primaryShadow: 'none',
      borderRadius: 8,
      defaultBorderColor: '#535565',
      defaultShadow: 'none',
      paddingContentHorizontal: 15,
    },
    Checkbox: {
      colorPrimary: '#F9F9FA',
      colorPrimaryHover: '#F9F9FA',
      colorPrimaryBorder: '#A8AAB8',
      colorBgContainer: '#3C3D49',
      colorBorder: '#535565',
      borderRadiusSM: 4,
    },
    DatePicker: {
      colorPrimary: '#A8AAB8',
      colorPrimaryHover: '#A8AAB8',
      colorPrimaryActive: '#8F91A3',
      borderRadius: 6,
      colorTextPlaceholder: '#6A6D81',
      colorBorder: '#535565',
      colorText: '#F9F9FA',
      colorTextSecondary: '#A8AAB8',
      colorLink: '#A8AAB8',
      colorLinkHover: '#A8AAB8',
      colorBgContainer: '#3C3D49',
      controlItemBgActive: 'rgba(168, 170, 184, 0.15)',
      controlItemBgHover: 'rgba(168, 170, 184, 0.08)',
    },
    Modal: {
      borderRadiusLG: 8,
      boxShadow:
        '0px 6px 16px 0px rgba(0,0,0,0.2),0px 3px 6px -4px rgba(0,0,0,0.24),0px 9px 28px 8px rgba(0,0,0,0.15)',
    },
    Select: {
      optionActiveBg: 'rgba(168, 170, 184, 0.15)',
      optionSelectedBg: 'rgba(168, 170, 184, 0.15)',
      optionSelectedFontWeight: 600,
      selectorBg: '#24252C',
      colorBorder: '#535565',
      colorText: '#F9F9FA',
      colorTextPlaceholder: '#6A6D81',
      borderRadius: 4,
      controlHeight: 30,
      fontSize: 14,
      colorPrimaryHover: '#A8AAB8',
      colorPrimaryBorderHover: '#A8AAB8',
      colorPrimaryBorder: '#A8AAB8',
    },
    Tabs: {
      itemColor: '#A8AAB8',
      itemHoverColor: '#F9F9FA',
      itemSelectedColor: '#F9F9FA',
      inkBarColor: '#F9F9FA',
    },
    Menu: {
      itemBg: 'transparent',
      subMenuItemBg: 'transparent',
      itemColor: '#F9F9FA',
      itemHoverColor: '#F9F9FA',
      itemSelectedColor: '#F9F9FA',
      itemHoverBg: 'rgba(168, 170, 184, 0.08)',
      itemSelectedBg: 'rgba(168, 170, 184, 0.15)',
      groupTitleColor: '#A8AAB8',
    },
  },
};

/** @deprecated Use antdLightTheme or antdDarkTheme instead */
export const antdTheme = antdLightTheme;
